// extracted by mini-css-extract-plugin
module.exports = {"bgWrap":"styles_bgWrap__bSanQ"};